/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { Col, Container, Row, Card } from 'react-bootstrap';
import HttpErrorHandler from './HttpErrorHandler';
import './error.scss';
import ClientErrorImage from '../img/client-error.png';
import HttpHeader from 'src/Member/shared/httpheader';
const cName = HttpHeader.getCNAME();
class ClientErrorWidget extends Component {
  constructor(props) {
    super(props);

    console.log('Inside clienterror');
    this.state = {
      backtoLogin: false,
    };
  }

  render() {
    return (
      <div>
        <Container fluid>
          <Card className="pl-3 pr-3 pt-4 pb-5" border="light">
            <Container>
              <Row className="h-100">
                <Col className="my-auto error-container">
                  <img
                    src={ClientErrorImage}
                    id="tick-img"
                    alt="Check Mark"
                    aria-hidden={true}
                  />
                  <Row className="w-100 mx-auto text-center error-msg">
                    <Col>
                      <h1 role="alert">Something went wrong!</h1>
                      {cName.includes('mybenefits') ||
                      cName.includes('roundstone') ? (
                        <>
                          <p role="alert">
                            {HttpErrorHandler.getErrorMessage()}{' '}
                            <a href="mailto:portalsupport@choosebywater.com">
                              mailto:portalsupport@choosebywater.com
                            </a>
                          </p>
                        </>
                      ) : (
                        <>
                          <p role="alert">
                            {HttpErrorHandler.getErrorMessage()}{' '}
                            <a href="mailto:tpacustomerservice@keenan.com">
                              mailto:tpacustomerservice@keenan.com
                            </a>
                          </p>
                        </>
                      )}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </Card>
        </Container>
      </div>
    );
  }
}

export default ClientErrorWidget;
